import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTranslation } from '../../actions/dataActions'
import * as systemSetting from '../../constants/SystemSettings'

class Ticket extends Component {

  render() {
    const {
    fontSize,
    ticketValidation
    } = this.props;

    const style = {
      fontSize: `${fontSize}px`,
    }

    return (
      <div style={style}>
      {ticketValidation &&
        <div id="ticketvalidation" className={`validation-result ${(ticketValidation.isValid ? "valid" : "invalid")}`}>
          {ticketValidation.message.split('\n').map(function(item, key) {
            return (
              <span key={key}>
                {item}
                <br/>
              </span>
            )
          })}
        </div>
      }
      </div>
    )
  }
}


function mapStateToProps(state) {
  return {
    fontSize: state.generalState.systemSettings[systemSetting.FONT_SIZE_CUSTOMER_DISPLAY]
  }
}

export default connect(mapStateToProps, { getTranslation })(Ticket)



// WEBPACK FOOTER //
// src/components/CustomerDisplay/Ticket.jsx